module.exports = __webpack_public_path__ + "img/message-in-svg.438be2b0.svg";